import React, { FC, useState } from "react";
import "./style.scss";
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { RialSeparator } from "../../utils/price-separator"
import Jalali from "../../utils/jalali"

const Transaction: FC = () => {
    const { status, info, type } = useSelector(({ payment }: any) => payment)
    const [redirect, setRedirect] = useState(false)
    const history = useHistory()

    let op;
    switch (info.operator_type_id) {
        case 1:
            op = "ایرانسل"
            break;
        case 2:
            op = "همراه اول"
            break;
        case 3:
            op = "رایتل"
            break;
        default:
    }

    const pan = info.user_pan?.split('').map((num: any, index: number) => {
        if (index < 6) {
            return (num)
        } else {
            return ('*')
        }
    })

    if (redirect || !info)
        history.push("/")

    return (
        <div className="main pt-4 mb-5">
            {/* @ts-ignore */}
            <Box display="flex" justifyContent="center">
                <Typography className={`${status}-text mx-1`}>تراکنش {status === "success" ? "موفق" : "ناموفق"}</Typography>
                <CheckCircleIcon className={`${status}-text mx-1`} />
            </Box>
            <Grid container justifyContent="center">
                <Grid item lg={4} md={6} xs={12}>
                    {/* @ts-ignore */}
                    <Box className="main-container pb-4">
                        {/* @ts-ignore */}
                        <Box display="flex" justifyContent="center"
                            className={`head-content ${status}-bg text-white py-3 mt-4`}>
                            <Typography>{type === 1 ? "شارژ " : "اینترنت"} {op}</Typography>
                        </Box>
                        <div className="container">
                            {/* @ts-ignore */}
                            <Box display="flex" justifyContent="space-between" className="mt-4">
                                <Typography className="small">{info.created_date && Jalali(info.created_date)}</Typography>
                                <Typography className="small">تاریخ و ساعت</Typography>
                            </Box>
                            {/* @ts-ignore */}
                            <Box display="flex" justifyContent="space-between" className="mt-4">
                                <Typography className="small">{RialSeparator(info.amount)}</Typography>
                                <Typography className="small">مبلغ انتقال</Typography>
                            </Box>
                            {/* @ts-ignore */}
                            <Box display="flex" justifyContent="space-between" className="mt-4">
                                <Typography className="small">{pan?.join('')}</Typography>
                                <Typography className="small">کارت بانکی</Typography>
                            </Box>
                            {/* @ts-ignore */}
                            <Box display="flex" justifyContent="space-between" className="mt-4">
                                <Typography className="small">{info.reference_number}</Typography>
                                <Typography className="small">کد رهگیری</Typography>
                            </Box>
                            <Paper className="paper text-center px-5 mt-5">
                                <Typography className="small pb-2 border-b">{type === 1 ? "شارژ مستقیم" : "خرید بسته اینترنت"} {op}</Typography>
                                {/* second transaction content
                                    <Box display="flex" justifyContent="space-between" className="pb-2 border-b">
                                        <Typography className="small">شارژ مستقیم ایرانسل</Typography>
                                        <Typography className="small">شارژ مستقیم ایرانسل</Typography>
                                    </Box>
                                */}
                                <Typography className="small pt-2">شماره تلفن : {info.mobile_number}</Typography>
                                {/* second transaction content
                                    <Box display="flex" justifyContent="space-between" className="pt-2">
                                        <Typography className="small">شارژ مستقیم ایرانسل</Typography>
                                        <Typography className="small">شارژ مستقیم ایرانسل</Typography>
                                    </Box>
                                */}
                            </Paper>
                            {/* @ts-ignore */}
                            <Box>

                                <Typography className={`small ${status}-text text-center my-3`}>
                                    {
                                        status === "success"
                                            ? ".تراکنش شما با موفقیت انجام شد"
                                            : info?.data
                                                ? info.data
                                                : info?.errors?.[0].detail

                                    }
                                </Typography>
                            </Box>
                            <Grid container>
                                <Grid item xs={12}>
                                    {/* @ts-ignore */}
                                    <Box>
                                        <Button variant="contained" className="back endBtn mt-4" onClick={() => setRedirect(true)}>
                                            بازگشت
                                        </Button>
                                    </Box>
                                </Grid>
                            </Grid>
                        </div>
                    </Box>
                </Grid>
            </Grid>
        </div>
    );
};

export default Transaction;
